import { Avatar, Grid, Typography } from "@mui/material";
import axios from "axios";
import moment from "moment";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { checkInPrenotazione } from "../../../../../../const/urlAction";
import handlerError from "../../../../../../functions/handlerError";
import { hideLoader, showLoader } from "../../../../../../redux/reducers/appLoader-reducer";
import { notificationOpen } from "../../../../../../redux/reducers/notification-reducer";
import { loadprenotazioniTableState } from "../../../../../../redux/reducers/prenotazioneTable-reducer";
import { Box } from "@mui/system";
import ResponseQrCode from "../../GeneralComponentQrCode/ResponseQrCode";
import { enumCheckInTypology } from "../../../../../../const/prenotazioni/enumCheckInTypology";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";

const grandezzaScritteCheckQr = "18px";

const urlBase = process.env.REACT_APP_URL;

export default function BodyComponentPostazioneCheckin({
  prenotazioneCheckIn,
  checkInDependency = 0,
  returnComponentState = () => {},
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation(); 

  useEffect(() => {
    if (checkInDependency) {
      (async () => {
        dispatch(showLoader());
        const { action, method } = checkInPrenotazione;
        let url = urlBase + action;
        try {
          const response = await axios({
            method: method,
            url,
            data: { id: prenotazioneCheckIn.id, checkInTypology: enumCheckInTypology.QrCodeCheckIn },
          });
          if (response.data.ok) {
            returnComponentState(false);
            dispatch(
              notificationOpen({
                message: response.data.message,
                status: "success",
              })
            );
          }
        } catch (error) {
          console.error(error);
          const notificationError = handlerError(error);
          dispatch(notificationOpen(notificationError));
        }
        dispatch(loadprenotazioniTableState());
        dispatch(hideLoader());
      })();
    }
  }, [checkInDependency]);

  return (
<>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        padding={2}
        boxSizing="border-box"
      >
        <Grid container>
{/*           <TitleScannedQrCode title="Check-in_booking" />
 */}        </Grid>
        <Grid container className="flex-center-center">
        <Grid mt={2} item xs={12} className="flex-center-center">
              {prenotazioneCheckIn.ospite || !prenotazioneCheckIn.immagineAvatar
                ? <Avatar
                  alt="Nome Utente"
                  children={<FontAwesomeIcon icon={faUser} className="avatarIcon" />}
                  sx={{ width: 100, height: 100 }}
                />
                :
                <Avatar
                  alt="Nome Utente"
                  src={"data:image/*;base64," + prenotazioneCheckIn.immagineAvatar}
                  sx={{ width: 100, height: 100 }}
                />
              }
            </Grid>
            {/* Nome e Cognome */}
            {prenotazioneCheckIn.ospite
              ? <>
                <Grid item xs={12}>
                  <Typography textAlign={"center"} variant="h6" fontWeight="bold">{prenotazioneCheckIn.ospite}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography textAlign={"center"} sx={{ color: "grey" }}>{t("guest_of_user")}{" "}{prenotazioneCheckIn.nominativo}</Typography>
                </Grid>
              </>
              :
              <Grid item xs={12}>
                <Typography textAlign={"center"} variant="h6" fontWeight="bold">{prenotazioneCheckIn.nominativo}</Typography>
              </Grid>
            }
              <Typography mt={1} className="cardRiepilogoText">
                {moment(prenotazioneCheckIn.dataOraInizioPrenotazione).format(
                  "HH:mm"
                )}{" "}
                -{" "}
                {moment(prenotazioneCheckIn.dataOraFinePrenotazione).format(
                  "HH:mm"
                )}
              </Typography>
            </Grid>
        <Grid mt={4} container>
          <ResponseQrCode
            text1={t("Confirm_check-in")}
            fontSize={grandezzaScritteCheckQr}
            className="flex-center-center"
          />
        </Grid>
      </Box>
    </>
  );
}
